namespace Roodik.Core
{
	export class HeyzapAdvertisment extends Advertisment
	{
		private HeyzapAds:any;
		private _available:boolean = false;
		private _dismissCount:number = 2;
		private _counter:number = 0;
		private _adRequested:boolean = false;

		constructor(config:IAdvertismentConfig)
		{
			super();

			this.HeyzapAds = window["HeyzapAds"];
			if(this.HeyzapAds)
			{
				this.HeyzapAds.start(config.id).then(()=>
				{
					let interstitialAd = this.HeyzapAds.InterstitialAd;
					interstitialAd.addEventListener(interstitialAd.Events.AVAILABLE,
					(tag) =>
					{
						// An ad is available for display.
						console.log("! HeyzapAds.VideoAd.Events.AVAILABLE");
						this._available = true;
						// interstitialAdState = AdStates.LOADED;
					});
					interstitialAd.addEventListener(interstitialAd.Events.SHOW,
					(tag) =>
					{
						// The ad was successfully shown.
						this.adFinished();
					});

					interstitialAd.addEventListener(interstitialAd.Events.HIDE,
					(tag) =>
					{
						// The ad successfully finished showing and is now off the screen.
						console.log("! HeyzapAds.VideoAd.Events.HIDE");
						this.adFinished();
					});

					interstitialAd.addEventListener(interstitialAd.Events.CLICKED,
					(tag) =>
					{
						// The ad was clicked/tapped
						// The user might be switched to the browser or an app store.
						console.log("! HeyzapAds.VideoAd.Events.CLICKED");
					});

					interstitialAd.addEventListener(interstitialAd.Events.SHOW_FAILED,
					(tag, error) =>
					{
						this._available = false;
						this.HeyzapAds.InterstitialAd.fetch();
						// The ad could not be shown successfully.
						console.log("! HeyzapAds.VideoAd.Events.SHOW_FAILED");
						// interstitialAdState = AdStates.UNLOADED;
					});

					interstitialAd.addEventListener(interstitialAd.Events.FETCH_FAILED,
					(tag, error) =>
					{
						// The ad could not be fetched.
						this.HeyzapAds.InterstitialAd.fetch();
						console.log("! HeyzapAds.VideoAd.Events.SHOW_FAILED");
					});

					interstitialAd.addEventListener(interstitialAd.Events.AUDIO_STARTED,
					() =>
					{
						// The ad will start playing audio.
						// Mute any music in the background.
						console.log("! HeyzapAds.VideoAd.Events.AUDIO_STARTED");
					});

					interstitialAd.addEventListener(interstitialAd.Events.AUDIO_FINISHED,
					(tag) =>
					{
						// The ad stop playing audio.
						// Resume any previously muted music.
						console.log("! HeyzapAds.VideoAd.Events.AUDIO_FINISHED");
					});

					if (config.debug)
					{
						//debug
						this.HeyzapAds.showMediationTestSuite();
					}

					//load
					//interstitialAd.fetch();
				});
			}
		}

		private adFinished()
		{
			this._resumeGameEvent.invoke();
			this.HeyzapAds.InterstitialAd.fetch();
		}

		public fetch()
		{
		}

		public show(force: boolean)
		{
			if (this.available)
			{
				if (force || this._dismissCount == this._counter)
				{
					if (!this._adRequested)
					{
						this._pauseGameEvent.invoke();
						this._counter = 0;
						this.HeyzapAds.InterstitialAd.show();
					}
					else
					{
						this._resumeGameEvent.invoke();
					}
				}
				else
				{
					if (!this._adRequested)
					{
						this._counter += 1;
					}
					this._resumeGameEvent.invoke();
				}
			}
		}

		public get available(): boolean
		{
			return this.HeyzapAds != null && this.HeyzapAds != undefined && this._available;
		}

	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Advertisment/HeyzapAdvertisment.ts